<template>
  <el-container class="fill-in header-main-layout">
    <el-header>
      <HomeHeader/>
    </el-header>
    <el-main class="main-container" :class="{ 'main-container--news': $route.path === '/information' }">
      <router-view></router-view>
      <FeedbackBut/>
    </el-main>
  </el-container>
</template>

<script>
import HomeHeader from "@/components/commonHeader";
import FeedbackBut from "@/components/feedbackBut";
export default {
  name: "HeaderMainLayout",
  components: {
    HomeHeader,
    FeedbackBut
  }
};
</script>
<style lang="scss" scoped>
.el-main {
  padding: 0 !important;
}
.el-main.main-container--news {
  overflow: visible;
}
.el-header {
  padding: 0 !important
}
</style>
